import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";

export default function CaptureUserIDentered(props) {
    // initalize a new BCMSStateManagerCRUD instance using the default page data
    // updating the modal property
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "georgew")
    .update([ "password" ], "")
    .update([ "userIDValOnChange" ], "georgew")
    .update([ "passwordValOnChange" ], "")
    .submit();

    return <LoginPage data={ data } />
}
